module.exports = __webpack_public_path__ + "static/hyperv_12.1eff2bbd.jpg";